Namespace 'Customer.Ticket'

class Customer.Ticket.OngoingSurveyView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/ongoing_survey']
  className: 'survey-notice'

  initialize: ({datetime}) ->
    @datetime = datetime

  render: ->
    @$el.html @template
      datetime: @datetime
    @
